import React from 'react';
import DividerNPM from '@rotaryintl/component-divider';
import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';

const Divider = ({ fields: { Thickness } }) => {
  return <DividerNPM thickness={Thickness?.fields?.Value?.value} />;
};

export default withSitecoreContext()(Divider);